var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "linkWrapper",
      class: [
        { linkText: !_vm.hasUrl },
        _vm.arrowIfNotLink,
        { isSp: _vm.isSp },
      ],
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _vm.hasUrl
        ? _c(
            "a",
            {
              staticClass: "linkText",
              class: _vm.arrowType,
              attrs: { href: _vm.linkUrl, target: _vm.targetValue },
            },
            [_vm._v("\n    " + _vm._s(_vm.linkText) + "\n  ")]
          )
        : [_vm._v("\n    " + _vm._s(_vm.linkText) + "\n  ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }